(function HotelEngineReviews($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['close-modal'],
		props: {
			giataId: {
				type    : Number,
				required: true,
			},
			hotelName: {
				type   : String,
				default: '',
			},
			showCloseFooter: {
				type   : Boolean,
				default: false,
			},
		},
		template: `
			<div class="hotel-reviews-modal">
				<header v-if="hotelName" class="hotel-reviews-modal-intro">
					<p class="hotel-reviews-modal-label">Reviews for</p>
					<h2 class="hotel-reviews-modal-title">{{ hotelName }}</h2>
				</header>

				<div v-if="reviewLoading" class="hotel-reviews-modal-loading">
					<adzuki-loading></adzuki-loading>
				</div>

				<div v-else-if="reviews" class="hotel-reviews-modal-body">
					<div v-if="reviewSummary" class="hotel-reviews-ai-summary">
						<div class="hotel-reviews-ai-summary-header">
							<span class="hotel-reviews-ai-summary-icon" aria-hidden="true">
								<i class="fas fa-file-alt"></i>
								<i class="fas fa-magic"></i>
							</span>
							<strong class="hotel-reviews-ai-summary-title">AI Summary</strong>
						</div>
						<p class="hotel-reviews-ai-summary-text">{{ reviewSummary }}</p>
					</div>

					<div
						v-for="(review, index) in reviews.verified.recent"
						:key="index"
						class="hotel-review-modal-card"
					>
						<div class="hotel-review-modal-card-header">
							<div class="hotel-review-modal-name">{{ review.reviewer_name }}</div>
							<div v-if="review.rating" class="hotel-review-modal-rating">
								{{ formatRating(review.rating) }}
							</div>
						</div>
						<div class="hotel-review-modal-date" v-format-date="review.date_submitted"></div>
						<div class="hotel-review-modal-text">{{ review.text }}</div>
					</div>
				</div>

				<footer v-if="showCloseFooter" class="hotel-reviews-modal-footer">
					<button
						type="button"
						class="hotel-reviews-modal-close-btn"
						@click="$emit('close-modal')"
					>Close</button>
				</footer>
			</div>
		`,
		data() {
			return {
				baseUri: Adzuki.base_uri,
				reviews: {
					verified: {
						recent: [],
					},
				},
				reviewSummary: '',
				reviewLoading: true,
			};
		},
		computed: {
		},
		methods: {
			formatRating(rating) {
				if (rating === null || rating === undefined || rating === '') {
					return '';
				}

				return Number(rating).toFixed(1);
			},
			loadReviews() {
				this.reviewLoading = true;
				const url = `${this.baseUri}/HotelEngine/reviews/${this.giataId}`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Failed to fetch reviews: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.reviews.verified = {
							...data.verified,
						};
						this.reviewSummary = data.summary;
						this.reviewLoading = false;
					})
					.catch(error => {
						console.error('Error fetching reviews:', error);
						this.reviewLoading = false;
					});
			},
		},
		watch: {
		},
		mounted() {
			this.loadReviews();
		}
	};

	Adzuki.VueComponents.HotelEngineReviews = component;
}(jQuery, window.Adzuki || {}));
